<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-survey',
};
</script>


// WEBPACK FOOTER //
// src/pages/polls/page-survey.vue